module.exports = __webpack_public_path__ + "img/esign-icon.5b681c60.svg";